module.exports = __webpack_public_path__ + "media/images/stock_groups/ef42-a6c4eec4d6c1bc28e1661048c291f91f.svg";